<template>
  <div id="kt_aside" class="aside overflow-visible pb-5 pt-5 pt-lg-0" data-kt-drawer="true" data-kt-drawer-name="aside" data-kt-drawer-activate="{default: true, lg: false}" data-kt-drawer-overlay="true" data-kt-drawer-width="{default:'80px', '300px': '140px'}" data-kt-drawer-direction="start" data-kt-drawer-toggle="#kt_aside_mobile_toggle">
    <div class="aside-logo py-8" id="kt_aside_logo">
      <router-link :to="{name: 'Index'}" class="d-flex align-items-center">
        <img alt="Logo" :src="require('@/assets/media/logos/demo6.svg')" class="h-45px logo" />
      </router-link>
    </div>
    <div class="aside-menu flex-column-fluid" id="kt_aside_menu">
      <div class="hover-scroll-y my-2 my-lg-5 scroll-ms" id="kt_aside_menu_wrapper" data-kt-scroll="true" data-kt-scroll-height="auto" data-kt-scroll-dependencies="#kt_aside_logo, #kt_aside_footer" data-kt-scroll-wrappers="#kt_aside, #kt_aside_menu" data-kt-scroll-offset="5px">
        <div class="menu menu-column menu-title-gray-700 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500 fw-semibold" id="#kt_aside_menu" data-kt-menu="true">
          <div class="menu-item py-2">
            <router-link :to="{name: 'Index'}" class="menu-link menu-center">
              <span class="menu-icon me-0">
                <i class="ki-outline ki-home-2 fs-2x"></i>
              </span>
              <span class="menu-title">Главная</span>
            </router-link>
          </div>
          <div v-if="false" class="menu-item py-2">
            <router-link :to="{name: 'Users'}" class="menu-link menu-center">
              <span class="menu-icon me-0">
                <i class="ki-outline ki-people fs-2x"></i>
              </span>
              <span class="menu-title">Клиенты</span>
            </router-link>
          </div>
          <div class="menu-item py-2" :class="this.$route.name === 'Orders' || this.$route.name === 'Archive' ? ' here show' : ''" data-kt-menu-trigger="{default: 'click', lg: 'hover'}" data-kt-menu-placement="right-start" >
            <span class="menu-link menu-center">
              <span class="menu-icon me-0">
                <i class="ki-outline ki-questionnaire-tablet fs-2x"></i>
              </span>
              <span class="menu-title">Заказы</span>
            </span>
            <div class="menu-sub menu-sub-dropdown px-2 py-4 w-250px mh-75 overflow-auto">
              <div class="menu-item">
                <router-link :to="{name: 'Orders'}" class="menu-link">
                 <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">Сегодня</span>
                </router-link>
              </div>
              <div class="menu-item">
                <router-link :to="{name: 'Archive'}" class="menu-link">
                 <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">Архив</span>
                </router-link>
              </div>
            </div>
          </div>
          <div class="menu-item py-2">
            <router-link :to="{name: 'Map'}" class="menu-link menu-center">
              <span class="menu-icon me-0">
                <i class="ki-outline ki-map fs-2x"></i>
              </span>
              <span class="menu-title">Карта</span>
            </router-link>
          </div>
          <div class="menu-item py-2">
            <router-link :to="{name: 'Analysis'}" class="menu-link menu-center">
              <span class="menu-icon me-0">
                <i class="ki-outline ki-graph-up fs-2x"></i>
              </span>
              <span class="menu-title">Анализ</span>
            </router-link>
          </div>
          <div class="menu-item py-2" :class="this.checkRouteName(this.$route.path) ? ' here show' : ''" data-kt-menu-trigger="{default: 'click', lg: 'hover'}" data-kt-menu-placement="right-start" >
            <span class="menu-link menu-center">
              <span class="menu-icon me-0">
                <i class="ki-outline ki-percentage fs-2x"></i>
              </span>
              <span class="menu-title">EnerGo Club</span>
            </span>
            <div class="menu-sub menu-sub-dropdown px-2 py-4 w-250px mh-75 overflow-auto">
              <div class="menu-item">
                <router-link :to="{name: 'TicketList'}" class="menu-link" :class="this.$route.path.includes('tickets') ? ' active exact-active here show' : ''">
                 <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">Абонементы</span>
                </router-link>
              </div>
              <div class="menu-item">
                <router-link :to="{name: 'Banner'}" class="menu-link" :class="this.$route.path.includes('banner') ? ' active exact-active here show' : ''">
                 <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">Баннер</span>
                </router-link>
              </div>
              <div class="menu-item">
                <router-link :to="{name: 'NotificationTemplate'}" class="menu-link" :class="this.$route.path.includes('notification') ? ' active exact-active here show' : ''">
                 <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">Уведомления</span>
                </router-link>
              </div>
              <div class="menu-item">
                <router-link :to="{name: 'PriceCampaign'}" class="menu-link" :class="this.$route.path.includes('price-campaigns') ? ' active exact-active here show' : ''">
                 <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">Ценовые кампании</span>
                </router-link>
              </div>
            </div>
          </div>
          <div class="menu-item py-2">
            <router-link :to="{name: 'Reports'}" class="menu-link menu-center">
              <span class="menu-icon me-0">
                <i class="ki-outline ki-document fs-2x"></i>
              </span>
              <span class="menu-title">Отчеты</span>
            </router-link>
          </div>
          <div class="menu-item py-2 station-ads-item">
            <a
              href="http://192.71.151.225:8780/adc/login_toLogin"
              target="_blank"
              rel="noopener noreferrer"
              class="menu-link menu-center"
            >
              <span class="menu-icon me-0">
                <i class="ki-outline ki-picture fs-2x"></i>
              </span>
              <span class="menu-title">Реклама на станциях</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'VAside',
  methods: {
    checkRouteName(routePath) {
      const words = ["tickets", "banner", "promo", "notification", "price-campaigns"];
      const hasWord = words.some(word => routePath.includes(word));
      return hasWord;
    }
  }
}
</script>

<style scoped>
.station-ads-item :deep(.menu-title) {
  text-align: center;
  white-space: normal;
  line-height: 1.2;
}
</style>